import { render, staticRenderFns } from "./AvailabilityPeriodForm.vue?vue&type=template&id=2944135c&"
import script from "./AvailabilityPeriodForm.vue?vue&type=script&lang=js&"
export * from "./AvailabilityPeriodForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports